import { chakra } from '@chakra-ui/react'

import { SCROLL_BAR_WIDTH } from 'src/utils/dom'
import { LANGUAGE_SELECT_CLASSNAME } from 'src/components/LanguageSelect/LanguageSelect'
import { FONT_SIZE_CONTROL_CLASSNAME } from 'src/components/FontSizeControl/FontSizeControl'
import { shouldForwardProp } from 'src/utils/should-forward-prop'

import { TRANSCRIPT_TOOLBAR_BUTTON_CLASSNAME } from './TranscriptToolbarButton'

const BAR_PADDING_MOBILE = 20

export const TranscriptToolbarBar = chakra('div', {
    baseStyle: ({ theme }) => ({
        width: '100%',
        minWidth: '460px',
        height: `${theme.dimensions.trancriptToolbarHeight}px`,
        zIndex: theme.zIndexes.trancriptToolbar,
        backgroundColor: theme.palette.transcript.toolbarOuterBackground,
        paddingBlock: 0,
        paddingInlineEnd: `${SCROLL_BAR_WIDTH}px`,
        paddingInlineStart: '6px',
        flexShrink: 0,

        [`@container (max-width: ${theme.breakPoints.mobilePhoneMaxWidth}px)`]: {
            padding: `0 ${BAR_PADDING_MOBILE + SCROLL_BAR_WIDTH}px 0 ${BAR_PADDING_MOBILE}px`,
        },
    }),
})

export const TOGGLE_THEME_BUTTON_CLASSNAME = 'palette'

type TranscriptToolbarLimiterProps = {
    $paragraphTotalWidth: number
}
export const TranscriptToolbarLimiter = chakra<'div', TranscriptToolbarLimiterProps>('div', {
    baseStyle: ({ $paragraphTotalWidth, theme }) => ({
        width: '100%',
        maxWidth: `${$paragraphTotalWidth}px`,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        margin: '0 auto',

        [`& .${TRANSCRIPT_TOOLBAR_BUTTON_CLASSNAME}`]: {
            margin: '0 2px',
            [`&.${TOGGLE_THEME_BUTTON_CLASSNAME}`]: {
                marginRight: 0,
            },
        },

        [`& .${LANGUAGE_SELECT_CLASSNAME}, & .${FONT_SIZE_CONTROL_CLASSNAME}`]: {
            margin: '0 2px',
            [`&.${TRANSCRIPT_TOOLBAR_BUTTON_CLASSNAME}`]: {
                margin: 0,
            },
        },

        [`@container (max-width: ${theme.breakPoints.mobilePhoneMaxWidth}px)`]: {
            maxWidth: 'unset',
        },
    }),
    shouldForwardProp,
})

export const LanguageButtonContent = chakra('span', {
    baseStyle: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '0 4px',
        gap: '8px',
    },
})

export const LanguageName = chakra('span', {
    baseStyle: {
        maxWidth: '82px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineHeight: '20px',
    },
})

export const MediaPlayerToggleWrapper = chakra('div', {
    baseStyle: {
        flexShrink: 0,
        margin: '0 4px 0 16px',
    },
})
